import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ColorModeIconDropdown from '../../shared-theme/ColorModeIconDropdown';
import { Link } from '@mui/material';
import { loginPage, signupPage } from '../../Constants';
import Sitemark from './SitemarkIcon';
import AppLink from './AppLink';
import { BlurFade } from '../../animations/BlurFade';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.6)`
    : alpha(theme.palette.background.default, 0.6),
  padding: '8px 12px',
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box sx={{ display: 'flex', alignItems: 'center', px: 0 }}>
            <Sitemark />
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, alignItems: 'center' }}>
            <Button variant="text" size="small" sx={{ color: '#999999' }} href="/#features">
              Features
            </Button>
            <Button variant="text" size="small" sx={{ color: '#999999' }} href="/#testimonials">
              Reviews
            </Button>
            <Button variant="text" size="small" sx={{ color: '#999999' }} href="/#pricing">
              Pricing
            </Button>
            <Button variant="text" size="small" sx={{ color: '#999999', minWidth: 0 }} href="https://help.tradespad.com" target='_blank'>
              Help Center
            </Button>
            <Button variant="text" size="small" sx={{ color: '#999999', minWidth: 0 }} href="/#faq">
              FAQ
            </Button>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 1,
              alignItems: 'center',
            }}
          >
            <AppLink href={loginPage}>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: '#181818',
                  color: '#FFFFFF',
                  border: 'none',
                  boxShadow: 'none',
                  textTransform: 'none',
                  height: 32,
                  '&:hover': {
                    backgroundColor: '#222222',
                    boxShadow: 'none',
                    border: 'none',
                  },
                }}
              >
                Sign in
              </Button>
            </AppLink>
            <AppLink href={signupPage}>
              <Button color="primary" variant="contained" size="small" sx={{ height: 30, textTransform: 'none' }}>
                Get Started
              </Button>
            </AppLink>
            {/* <ColorModeIconDropdown />*/}
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, gap: 1 }}>
            {/* <ColorModeIconDropdown size="medium" /> */}
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="top"
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  top: 'var(--template-frame-height, 0px)',
                },
              }}
            >
              <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>

                <MenuItem><Link href="/#features">Features</Link></MenuItem>
                {/*<MenuItem>Testimonials</MenuItem>*/}
                <MenuItem><Link href="/#pricing">Pricing</Link></MenuItem>
                <MenuItem><Link href="/#faq">FAQ</Link></MenuItem>
                <MenuItem><Link href="https://help.tradespad.com/" target='_blank'>Help Center</Link></MenuItem>
                {/*<MenuItem>Blog</MenuItem>*/}
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                  <Button color="primary" variant="contained" href={signupPage} fullWidth>
                    Get Started
                  </Button>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="outlined" href={loginPage} fullWidth>
                    Sign in
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
